// Build-time env validation. Same shape as apps/dashboard/src/env.ts so a
// developer who knows one knows both; the small differences are noted below.

interface AdminEnv {
  readonly clerkPublishableKey: string;
  readonly apiBaseUrl: string;
}

function readEnv(): AdminEnv {
  const raw: Record<string, unknown> = import.meta.env;
  const clerkPublishableKey = raw['VITE_CLERK_PUBLISHABLE_KEY'];
  const apiBaseUrlRaw = raw['VITE_API_BASE_URL'];

  if (!clerkPublishableKey || typeof clerkPublishableKey !== 'string') {
    throw new Error(
      'VITE_CLERK_PUBLISHABLE_KEY is required. Copy .env.example to .env.local and fill it in.',
    );
  }
  const apiBaseUrl =
    typeof apiBaseUrlRaw === 'string' && apiBaseUrlRaw.length > 0
      ? apiBaseUrlRaw
      : 'http://localhost:3000';

  return {
    clerkPublishableKey,
    apiBaseUrl: apiBaseUrl.replace(/\/$/, ''),
  };
}

export const env: AdminEnv = readEnv();
